import { branding } from '@/config/branding'

interface LogoMarkProps {
	/** Rendered box in pixels. The mark is letterboxed into it, so a non-square asset is not stretched. */
	size?: number
	'data-testid': string
}

function LogoMark({ size = 16, 'data-testid': dataTestId }: LogoMarkProps) {
	return (
		<img
			src={branding.images.logoMark}
			alt={`${branding.productName} mark`}
			className='object-contain'
			// Tailwind preflight sets `img { height: auto }`, which beats the width/height attributes.
			style={{ width: size, height: size }}
			data-testid={dataTestId}
		/>
	)
}

export default LogoMark
